// This file was auto-generated by Fern from our API Definition.
export const OTelSpanKind = {
    SpanKindUnspecified: "SPAN_KIND_UNSPECIFIED",
    SpanKindInternal: "SPAN_KIND_INTERNAL",
    SpanKindServer: "SPAN_KIND_SERVER",
    SpanKindClient: "SPAN_KIND_CLIENT",
    SpanKindProducer: "SPAN_KIND_PRODUCER",
    SpanKindConsumer: "SPAN_KIND_CONSUMER",
};
